import BaseService from '@/services/BaseService'
import { http } from './config'
import moment from 'moment'
class ContaReceberService extends BaseService {
    constructor() {
        super('/v1/contas-receber')
    }

    listar(data){
        // const queryParams = `
        //     id=${data.id ? data.id : ''}
        //     &cliente=${data.cliente ? data.cliente : ''}
        //     &situacao=${data.situacao ? data.situacao : ''}
        //     &dataVencimento=${data.dataVencimento ? data.dataVencimento : ''}
        //     &periodo_final=${data.periodo_final ? data.periodo_final : ''}
        //     &periodo_inicial=${data.periodo_inicial ? data.periodo_inicial : ''}
        //     &limit=${data.limit ? data.limit : ''}
        //     &page=${data.page ? data.page : 1}
        //     &content=${data.content ? data.content : 'json'}
        // `;

        return http.get(`/v1/contas-receber`, {params: data})
    }
    listarPorPeriodo(data) {
        return http.get(`/v1/contas-receber?periodo_inicial=${data.periodo_inicial}&periodo_final=${data.periodo_final}&content=${data.content}&situacao=${data.situacao}`)
    }

    baixar(data){
        return http.post(`/v1/conta-receber/${data.id}/baixar`, data)
    }

    atualizar(data) {
        const id = data.get('id')
        return http.post(`/v1/contas-receber/${id}`, data)
    }
    
    reciboParcial(data){
        const queryParams = `
            modelo_impressao=${data.modelo_impressao ? data.modelo_impressao : ''}
        `;
        return http.get(`/v1/extrato/movimentacao/${data.id}/recibo/conta-receber?${queryParams}`)
    }
    
    reciboTotal(data){
        const queryParams = `
            modelo_impressao=${data.modelo_impressao ? data.modelo_impressao : ''}
        `;
        return http.get(`/v1/conta-receber/${data.id}/recibo?${queryParams}`)
    }
}

export default new ContaReceberService